module.exports = __webpack_public_path__ + "static/media/NAC---Desktop-UI---About Us, FAQ, Privacy, T&C-7.jpg";